'use strict';

angular.module('webAgro1App').factory('DadosMeteorologicosService', function($http) {
  return {
    list(filters) {
      var url = SERVER + API_VERSION + 'dados_meteorologicos';
      return $http.get(url, {params: filters});
    },

    previsaoDoTempo(propriedade) {
      return $http.get(`${SERVER}v1/propriedades/${propriedade}/weather`);
    }
  };
});
